import {
  AppleIcon,
  GithubIcon,
  Odnoklassniki,
  TBankIcon,
  VkIcon,
  YandexIcon,
} from '@lt/components/icons-react/auth';
import React from 'react';
import type { SocialNetworkNames } from '../../utils/socialNetworkUtils';

export interface SocialAuthMethods {
  icon: React.ReactNode | JSX.Element;
  networkName: SocialNetworkNames;
  isShow: boolean;
}

const getIsTinkoffAndTestWl = () => {
  try {
    const host = window.location.hostname;
    return (
      host === 'staging-epsilon.level.travel' ||
      host === 'staging-prod2.level.travel' ||
      host === 'staging-wl.level.travel' ||
      host === 'tbank.level.travel' ||
      host === 'tbank-tours.level.travel' ||
      host === 'tbank-hotels.level.travel'
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
  return false;
};

export const getSocialAuthMethods = (isWl = false): SocialAuthMethods[] => [
  {
    icon: <VkIcon width={33} height={33} />,
    networkName: 'vk',
    isShow: !isWl,
  },
  {
    icon: <YandexIcon width={33} height={33} />,
    networkName: 'yandex',
    isShow: !isWl,
  },
  {
    icon: <Odnoklassniki width={33} height={33} />,
    networkName: 'ok',
    isShow: !isWl,
  },
  {
    icon: <AppleIcon width={33} height={33} />,
    networkName: 'apple',
    isShow: !isWl,
  },
  {
    icon: <GithubIcon width={33} height={33} />,
    networkName: 'github',
    isShow: !isWl,
  },
  {
    icon: <TBankIcon width={33} height={33} />,
    networkName: 'tbank',
    isShow: !isWl || getIsTinkoffAndTestWl(),
  },
];
